(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["collection-top-bar"] && !Shopify.designMode) return;
  try {
    // CRITICAL: Prevent race conditions and memory leaks in filter updates
  // - Only one fetch request can be in flight at a time
  // - Debounce rapid changes to reduce server load
  // - Validate response before updating DOM
  // - Clean up old event listeners before replacing section

  let pendingFetch = null;
  let debounceTimer = null;
  const DEBOUNCE_DELAY = 300; // ms

  const cleanupOldListeners = (section) => {
    // Remove accordion listeners from old section before replacing
    const oldAccordions = section.querySelectorAll('[data-subcollection-item]');
    oldAccordions.forEach(accordion => {
      const toggleBtn = accordion.querySelector('[data-toggle-accordion]');
      if (toggleBtn) {
        toggleBtn.replaceWith(toggleBtn.cloneNode(true)); // Remove listeners
      }
    });
  };

  const updateFilterResults = async (url, sectionId) => {
    const section = document.getElementById(`shopify-section-${sectionId}`);
    if (!section) return;

    try {
      // Cancel previous fetch if still in progress
      if (pendingFetch) {
        pendingFetch.controller.abort();
      }

      // Create new AbortController for this request
      const controller = new AbortController();
      pendingFetch = { controller, sectionId };

      section.classList.add('is-loading');

      const response = await fetch(url.toString(), { signal: controller.signal });

      // Validate HTTP response
      if (!response.ok) {
        console.error(`Filter update failed: HTTP ${response.status}`);
        return;
      }

      const html = await response.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const newSection = doc.getElementById(`shopify-section-${sectionId}`);

      // Validate section exists in response
      if (!newSection) {
        console.error('Filter update failed: Section not found in response');
        return;
      }

      // Clean up old listeners before replacing DOM
      cleanupOldListeners(section);

      // Replace section content
      section.replaceChildren(...newSection.childNodes);

      // Reinitialize accordion functionality
      window.initSubcollectionAccordions?.();

    } catch (error) {
      // Ignore abort errors (intentional cancellation)
      if (error.name !== 'AbortError') {
        console.error('Filter update error:', error.message);
      }
    } finally {
      section.classList.remove('is-loading');
      if (pendingFetch?.sectionId === sectionId) {
        pendingFetch = null;
      }
    }
  };

  document.addEventListener('change', (event) => {
    const target = event.target;
    if (target.type === 'checkbox' || target.type === 'number') {
      const form = target.closest('form[section-id]');
      if (!form) return;

      // Debounce: Clear previous timer and set new one
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(() => {
        const sectionId = form.getAttribute('section-id');
        const url = new URL(form.action || window.location.href);
        url.search = '';

        // Collect only non-hidden inputs
        const inputs = form.querySelectorAll('input[type="checkbox"], input[type="number"], input[name="sort_by"]');
        inputs.forEach(input => {
          if (input.type === 'checkbox' && input.checked) {
            url.searchParams.append(input.name, input.value);
          } else if (input.type === 'number' && input.value) {
            url.searchParams.append(input.name, input.value);
          }
        });

        // Add hidden inputs (q for search, type for search, etc)
        const hiddenInputs = form.querySelectorAll('input[type="hidden"]');
        hiddenInputs.forEach(input => {
          if (input.value && !url.searchParams.has(input.name)) {
            url.searchParams.append(input.name, input.value);
          }
        });

        // Update browser URL
        history.replaceState({}, '', url.toString());

        // Fetch and update section
        updateFilterResults(url, sectionId);
      }, DEBOUNCE_DELAY);
    }
  });
  } catch(e) { console.error(e); }
})();

})();
